<template>
    <div>
        <v-layout wrap align-center>
            <v-flex xs12 sm4 d-flex>
                <div class="az-text">
                    <label>Número do Processo</label>
                    <p>{{ value.numeroProcesso }}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm4 d-flex>
                <div class="az-text">
                    <label>Número do Edital</label>
                    <p>{{ value.numeroEdital != null ? value.numeroEdital : "--" }}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm4 d-flex>
                <div class="az-text">
                    <label>Data de Publicação</label>
                    <p>{{ value.dataPublicacao | az-date('DD/MM/YYYY HH:mm:ss') }}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm4 d-flex>
                <div class="az-text">
                    <label>Modalidade</label>
                    <p>{{ value.modalidade != null ? value.modalidade : "--" }}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm4 d-flex>
                <div class="az-text">
                    <label>Objeto</label>
                    <p>{{ value.objeto != null ? value.objeto : "--" }}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm4 d-flex>
                <div class="az-text">
                    <label>Responsável</label>
                    <p>{{ value.responsavel != null ? value.responsavel : "--" }}</p>
                </div>
            </v-flex>

            <v-divider></v-divider>

            <v-flex xs12 sm12 d-flex>
                <span class="az-subtitle primary--text">Anexos</span>
            </v-flex>

            <v-flex xs12>
                <div class="az-text">
                    <div v-if="Array.isArray(value.anexos) && value.anexos.length">
                        <ul>
                            <li v-for="anexo in value.anexos" :key="anexo.id">
                                <a class="az-action-link-icon" target="_blank" @click.prevent="downloadAnexo(anexo)">
                                    {{ anexo.nome }}
                                    <v-icon size="20px">download</v-icon>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div v-else class="sem-anexos-esc-ipm">
                        <v-icon size="20">info</v-icon>
                        <span>Esta licitação não possui anexos</span>
                    </div>
                </div>
            </v-flex>

            <v-divider></v-divider>

            <v-flex xs12 sm12 d-flex>
                <span class="az-subtitle primary--text">Ata</span>
            </v-flex>

            <div class="az-text ml-3 mr-2">
                <label>Tipos:</label>
            </div>

            <v-flex xs12 sm2 d-flex pt-4>
                <v-select
                    v-model="loteSelecionado"
                    :items="lotes"
                    item-text="descricao"
                    item-value="id"
                    dense
                ></v-select>
            </v-flex>

            <v-flex xs12 sm2 d-flex>
                <v-btn outlined @click="verAta">Ver Ata</v-btn>
            </v-flex>
        </v-layout>
        <v-spacer style="height: 20px;"></v-spacer>
    </div>
</template>

<script>
import {actionTypes} from "@/commons/constants";
import {mapActions} from "vuex";

export default {
    name: 'DetalhesDadosLicitacaoDadosGerais',
    props: {
        value: {
            required: true
        },
        lotes: {
            required: true
        }
    },
    data() {
        return {
            loteSelecionado: 0
        }
    },
    methods: {
        async verAta() {
            let lote = this.loteSelecionado;
            let processoLicita = this.$route.params.id;
            await this.gerarAtaUsiga({
                idProcessoLicita: processoLicita,
                loteId: lote
            })
        },
        async downloadAnexo(anexo) {
            await this.downloadAnexoUsiga({
                idAnexo: anexo.id,
                nomeAnexo: anexo.nome,
                tipo: anexo.tipoDocumentoUSiga
            })
        },
        ...mapActions({
            gerarAtaUsiga: actionTypes.GERAR_ATA_USIGA,
            downloadAnexoUsiga: actionTypes.DOWNLOAD_ANEXO_USIGA
        })
    }
}
</script>

<style>
.sem-anexos-esc-ipm {
    font-weight: bold;
    margin-top: 4px;
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: center;
    background-color: #cecece;
    border-radius: 5px;
}
</style>